import { render, staticRenderFns } from "./ActivityAreas.vue?vue&type=template&id=0946443a&scoped=true&"
import script from "./ActivityAreas.vue?vue&type=script&lang=js&"
export * from "./ActivityAreas.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAreas.vue?vue&type=style&index=0&id=0946443a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946443a",
  null
  
)

export default component.exports